// extracted by mini-css-extract-plugin
export var direction_horizontal = "Stack-module--direction_horizontal--686a0";
export var direction_vertical = "Stack-module--direction_vertical--728e3";
export var root = "Stack-module--root--1242a";